// removed by extract-text-webpack-plugin
module.exports = {"report":"src-components-QuestionList-ReportButton-report-2FKxg","button":"src-components-QuestionList-ReportButton-button-3CBPe"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/QuestionList/ReportButton.css
 ** module id = 279
 ** module chunks = 0
 **/